<template>
  <VerticalNavigator>
    <Breadcrumb
      :links="[{
        title: 'RutSolve',
        routeName: 'index'
      }, {
        title: 'Deliverables',
        routeName: 'deliverables'
      }]"
      title="Create"
    />
    <h1>
      Create Deliverable
    </h1>
    <DeliverableEditor v-model:value="deliverable" />
    <h2>
      Trademark
    </h2>
    <Button
      title="Trademark"
      @click="selectingTrademark = true"
    />
    <ContentModal v-if="selectingTrademark">
      <TrademarkSelector
        v-model:value="deliverable.trademark"
        @select="selectTrademark()"
      />
    </ContentModal>
    <br>
    <Button
      title="Cancel"
      @click="deliverableRedirect()"
    />
    <Button
      title="Save"
      @click="save()"
    />
  </VerticalNavigator>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import DeliverableEditor from "@/components/editors/deliverable.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Deliverable as DeliverableResolver} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import {ref} from "vue"
  import ContentModal from "@/components/modals/content.vue"
  import TrademarkSelector from "@/components/selectors/trademark.vue"

  const deliverableResolver = new DeliverableResolver()
  const deliverable = ref<Deliverable>({
    type: "PRODUCT"
  })
  const selectingTrademark = ref<boolean>(null)

  async function save() {
    await deliverableResolver.create(deliverable.value)
    deliverableRedirect()
  }

  function deliverableRedirect() {
    router.push({
      name: "deliverables"
    })
  }

  function selectTrademark() {
    deliverable.value.trademarkID = deliverable.value.trademark.id
    selectingTrademark.value = false
  }
</script>
